import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

import { configs } from '@hero/configs';
import { ROUTE_PATHS } from '@hero/routes';

class Boundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    const { hasError, error, errorInfo } = this.state;

    const errorPath = ROUTE_PATHS.ERROR; // '/error';
    const currentPath = window.location.pathname;
    const isOnErrorPath = currentPath === `${configs.publicUrl}${errorPath}`;

    if (configs.isProduction && hasError) {
      if (!isOnErrorPath) {
        return (
          <Navigate
            to={errorPath}
            state={{
              error,
              errorInfo
            }}
            replace
          />
        );
      } else {
        return null;
      }
    }

    return this.props.children;
  }
}

Boundary.propTypes = {
  children: PropTypes.node.isRequired
};

const ErrorBoundary = ({ children }) => {
  return <Boundary>{children}</Boundary>;
};

export { ErrorBoundary };

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};
